export default __webpack_public_path__ + "static/media/9.e422dea7.jpg";